import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Search, X } from "lucide-react";
import Logo from "../../../Assets/logo.png";
import './MobileHeader.css';

const MobileHeader = ({
    searchInput,
    setSearchInput,
    handleSearch,
    toggleMobileMenu,
    handleLogin
}) => {
    const [searchExpanded, setSearchExpanded] = useState(false);

    const toggleSearch = () => {
        setSearchExpanded(!searchExpanded);
    };

    return (
        <>
            <header className="mobile-header">
                <div className="mobile-header-content">
                    <div className="mobile-logo-container">
                        <Link to="/">
                            <img src={Logo} alt="Logo" className="mobile-logo" />
                        </Link>
                    </div>

                    <div className="mobile-actions">
                        <button
                            className="mobile-action-button"
                            onClick={toggleSearch}
                            aria-label="Rechercher"
                        >
                            {searchExpanded ? <X size={20} /> : <Search size={20} />}
                        </button>

                        <button
                            className="mobile-action-button"
                            onClick={toggleMobileMenu}
                            aria-label="Menu principal"
                        >
                            <Menu size={20} />
                        </button>
                    </div>
                </div>

                {searchExpanded && (
                    <div className="mobile-search-container">
                        <form onSubmit={handleSearch} className="mobile-search-form">
                            <div className="mobile-search-input-container">
                                <span className="mobile-search-icon">
                                    <Search size={16} />
                                </span>
                                <input
                                    type="text"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    placeholder="Rechercher..."
                                    className="mobile-search-input"
                                    autoFocus
                                />
                            </div>
                            <button type="submit" className="mobile-search-button">
                                GO
                            </button>
                        </form>
                    </div>
                )}
            </header>
        </>
    );
};

export default MobileHeader;